document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.ring-tabs').forEach((tabs) => {

    const wrapper = tabs.closest('.ring-size-popup');

    tabs.querySelectorAll('.ring-tab').forEach((button) => {

      button.addEventListener('click', () => {

        tabs.querySelectorAll('.ring-tab').forEach((tab) => {
          tab.classList.remove('active');
        });

        wrapper.querySelectorAll('.ring-tab-content').forEach((panel) => {
          panel.classList.remove('active');
        });

        button.classList.add('active');

        wrapper
          .querySelector('#' + button.dataset.tab)
          .classList.add('active');

      });

    });

  });

});